import React from "react";
import useProductInfo from "../context/ProductInfoProvider";
import {Alert} from "peggirkit";
import {FormattedMessage} from "react-intl";

const ProductUnavailableIndication = () => {
    const {matchingFulfillmentType} = useProductInfo();

    if (matchingFulfillmentType.match || matchingFulfillmentType.otherType === null) {
        return <></>;
    }

    return (
        <Alert
            type={"danger"}
            title={
                <FormattedMessage
                    id={`only-available-for.${matchingFulfillmentType.otherType}`}
                />
            }
        />
    );
};

export default ProductUnavailableIndication;